import React, { useEffect, useState } from "react";
import { Container, Button, ProgressBar } from "react-bootstrap";
import Step1 from "./KycSteps/Step1";
import Step2 from "./KycSteps/Step2";
import Step3 from "./KycSteps/Step3";
import StepOTP from "./KycSteps/SteOTP";
import { Link } from "react-router-dom";
import { getUserByAddress, UserDetailsWithAddress } from "../../../hooks/User";

const UserKyc = () => {
    const [step, setStep] = useState(1);
    const Address = localStorage.getItem("WalletAddress");
    const [formData, setFormData] = useState({
        userId: null,
        fullName: "",
        lastName: "",
        email: "",
        mobileNumber: "",
        dob: "",
        userPicture: null,
        address: { locality: "", city: "", state: "" },
        document: { type: "", number: "", frontImage: null, backImage: null },
    });

    const nextStep = () => setStep(step + 1);
    const prevStep = () => setStep(step - 1);

    const updateFormData = (field, value) => {
        setFormData({ ...formData, ...field });
    };
    useEffect(() => {
        getUserByAddress(Address).then((data) => {
            console.log("UserData", data);
            if (data.status === 200){
                const UserData = data.user;
            updateFormData({
                ...formData,
                ...UserData
            })
            }
        })
        UserDetailsWithAddress(Address).then((data)=>{
            console.log("Data", Address);   
        })
    }, [])

    const steps = [
        { component: <Step1 nextStep={nextStep} updateFormData={updateFormData} formData={formData} /> },
        { component: <Step2 nextStep={nextStep} prevStep={prevStep} updateFormData={updateFormData} formData={formData} /> },
        { component: <Step3 nextStep={nextStep} prevStep={prevStep} updateFormData={updateFormData} formData={formData}  /> },
        { component: <StepOTP formData={formData} prevStep={prevStep} /> },
    ];

    
    return (
        <>
            <div className="container">
                <Link to="/launchpad" className="btn btn-white btn-sm my-40">
                    back to LaunchPad
                </Link>
                <h2>KYC Registration</h2>
                <ProgressBar now={(step / steps.length) * 100} className="mt-3" style={{color:"red"}} />
                {steps[step - 1].component}
            </div >
        </>
    );
};

export default UserKyc;
